import CardRankings from "../../../../src/components/card-rankings/CardRankings";
import matRatings from "../../../../src/data/articles/cube-prospective-march-of-the-machine-the-aftermath/mat-prospective-ratings.json";
import ProspectiveIntro from "../../../../src/components/article-elements/ProspectiveIntro.tsx";
import * as React from 'react';
export default {
  CardRankings,
  matRatings,
  ProspectiveIntro,
  React
};